exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-services-actives-call-list-component .table td{cursor:pointer}.table-services-actives-call-list-component .table td .type-call{font-family:\"PT Mono\";font-style:normal;font-weight:normal;font-size:16px;line-height:18px;margin-top:20px;padding:4px 6px;border-radius:5px}.table-services-actives-call-list-component .table td .type-call.success{background-color:#6fcf97}.table-services-actives-call-list-component .table td .type-call.error{background-color:#ea2151;color:#fff}", ""]);

// exports
